'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PanZoom = require('./components/PanZoom.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PanZoom).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-pan-zoom/lib/components/pan-zoom/index.js
// module id = 1336
// module chunks = 1